<div class="audio-player" [ngClass]="{ 'is-playing': isPlaying }">
    <button (click)="togglePlay()" class="play-button">
    {{ isPlaying ? '❚❚' : '►' }}
    </button>
    <div class="progress-container" (click)="seek($event)">
    <div class="progress-bar" [style.transform]="'scaleX(' + (progressPercent / 100) + ')'"></div>
    </div>
    <span class="time-display">{{ currentTime | time }} / {{ duration | time }}</span>
    <audio #audioElement 
    [src]="audioSrc" 
    (loadedmetadata)="setDuration()"
    (ended)="onAudioEnd()">
    </audio>
</div>